import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import dayjs from 'dayjs';

const POLL_MS = 30_000;
const STALE_TICK_MS = 10 * 60_000; // amber threshold

function computeColor(status) {
  if (!status) return 'muted';
  if (!status.running) return 'danger';
  const last = status.lastTickAt ? new Date(status.lastTickAt).getTime() : 0;
  if (!last) return 'warn'; // running but never ticked yet
  const age = Date.now() - last;
  if (age > STALE_TICK_MS) return 'warn';
  return 'success';
}

const DOT = {
  success: 'text-steam-success',
  warn:    'text-steam-warn',
  danger:  'text-steam-danger',
  muted:   'text-surface-muted'
};

export default function SchedulerHealth() {
  const [status, setStatus] = useState(null);
  const [unreachable, setUnreachable] = useState(false);

  useEffect(() => {
    let mounted = true;
    let intervalId = null;

    async function fetchStatus() {
      if (document.hidden) return;
      try {
        const resp = await api.get('/api/health');
        if (!mounted) return;
        setStatus(resp.data.scheduler);
        setUnreachable(false);
      } catch {
        if (!mounted) return;
        setUnreachable(true);
      }
    }

    fetchStatus();
    intervalId = setInterval(fetchStatus, POLL_MS);
    const onVis = () => { if (!document.hidden) fetchStatus(); };
    document.addEventListener('visibilitychange', onVis);

    return () => {
      mounted = false;
      if (intervalId) clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  if (unreachable) {
    return (
      <span className="text-xs text-surface-muted" title="Health endpoint unreachable">
        <span className={DOT.muted}>●</span> Scheduler · unknown
      </span>
    );
  }

  const color = computeColor(status);
  const lastTickLabel = status?.lastTickAt
    ? dayjs(status.lastTickAt).fromNow(true)
    : 'never';

  return (
    <span
      className="text-xs text-surface-muted"
      title={status ? JSON.stringify(status.skipped, null, 2) : ''}
    >
      <span className={DOT[color]}>●</span> Scheduler · {lastTickLabel}
    </span>
  );
}
